import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import $, { error } from "jquery";
import { useFormik, FormikProvider, Field, ErrorMessage } from "formik";
import React, { useState, Fragment, useEffect } from "react";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import HousingService from "../../../Services/HousingService";
import { Form, Table } from "react-bootstrap";
import moment from "moment-timezone";
import { AiOutlineSearch } from "react-icons/ai";
import { store } from "../../../App";
import { ExportToExcelButton, GetDetails, LabelHeader, ModuleHeader } from "../../utils/commonFunctions";
import * as Yup from "yup";

const BankBookReport = () => {
  const [districts, setDistricts] = useState();
  const [tableEnable, settableEnable] = useState(false);
  const [tabledata, settabledata] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [bankNames, setbankNames] = useState();
  const [branch, setBranch] = useState([]);
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;
  const firstDayOfMonth = `${currentYear}-${currentMonth.toString().padStart(2, "0")}-01`;


  const validationSchema = Yup.object().shape({
    fromDate: Yup.string().required("required"),
    toDate: Yup.string().required("required"),
    security_id: Yup.string().required("required"),
    banknameaccountno: Yup.string().required("required"),
    banks: Yup.string().required("required"),
  });

  const formik = useFormik({
    initialValues: { fromDate: firstDayOfMonth, toDate: today.toISOString().substr(0, 10), security_id: "", banks: "", banknameaccountno: "", transaction_type: "0" },

    validationSchema: validationSchema,

    onSubmit: () => {
      let params = { fromDate: moment(formik.values.fromDate).format("DD-MM-YYYY"), toDate: moment(formik.values.toDate).format("DD-MM-YYYY"), security_id: formik.values.security_id, banks: formik.values.banks, banknameaccountno: formik.values.banknameaccountno, transaction_type: formik.values.transaction_type }; store.dispatch({ type: "SHOW_SPINNER" });
      HousingService.bankbook_fromdate_todate(params).then((res) => {
        if (res && res.data && res.data?.length > 0) { settabledata(res.data); }
        else { settabledata([]); }
      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
        settableEnable(true);
        setSearchText("");
      });
    }
  });
  const todayDate = new Date(); let year = todayDate.getUTCFullYear(); let month = todayDate.getMonth() + 1; let tDate = todayDate.getDate(); if (month < 10) { month = "0" + month; } if (tDate < 10) { tDate = "0" + tDate; } const maxDate = year + "-" + month + "-" + tDate;



  React.useEffect(() => {
    HousingService.CGG_District().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (<option key={i} value={item.code}> {item.name} </option>);
        });
        setDistricts(options);
      }
    });
    HousingService.fetchBankName().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          if (item !== null) {
            return (<option key={i} value={item.bankshortname}> {item.bankfullname} </option>);
          }
        }); setbankNames(options);
      }
    });
  }, []);

  useEffect(() => {

  }, []);


  const handleSearchBankBook = event => { setSearchText(event.target.value) }

  const filteredDataBankBook = searchText.length > 0 ? tabledata?.filter((data) => {
    return (
      data && Object.keys(data).some((key) => {
        const value = data[key];
        return (
          value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase()));
      }));
  }) : tabledata;

  const handleChangeDistrict = () => {
    formik.setFieldValue("banks", "");
    formik.setFieldValue("banknameaccountno", "");
    setBranch([]);
  };

  const handleChangeBranchName = (e) => {
    formik.setFieldValue("banknameaccountno", "");
    if (e.target.value != "" && formik.values.security_id !== "") {
      let params = { bankshortname: e.target.value };
      HousingService.fetchAccountNo(params).then((res) => {
        if (res.data) {
          let options = res.data.map((item, i) => (<option key={i} value={item.banknameaccountno}> {item.banknameaccountno} </option>));
          setBranch(options);
        }
      });
    }
    else {
      setBranch([]);
    }
  };

  return (
    <div>
      <NavigationServicesHeader />
      <ModuleHeader title="Bank Book Report" />
      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <OFMSUI.Row> <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>  <LabelHeader title="From date" />
              <Field name="fromDate" className={formik.touched.fromDate && formik.errors.fromDate ? "form-control is-invalid" : "form-control"} type="date" onChange={(e) => { formik.handleChange(e);  }} max={maxDate} /> <ErrorMessage name="fromDate" component={"div"} className="text-error" /> </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}> <LabelHeader title="To date" />
                <Field name="toDate" className={formik.touched.toDate && formik.errors.toDate ? "form-control is-invalid" : "form-control"} type="date" onChange={(e) => formik.handleChange(e)} max={maxDate} /> <ErrorMessage name="toDate" component={"div"} className="text-error" />  </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                <LabelHeader title="District Name" />
                <Field component="select" name="security_id" className={formik.touched.security_id && formik.errors.security_id ? "form-control is-invalid" : "form-control"} onChange={(e) => {
                  formik.handleChange(e);
                  handleChangeDistrict();

                }} >
                  <option value="">Select</option>
                  {districts}
                </Field>
                <ErrorMessage name="security_id" component={"div"} className="text-error" />
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                <LabelHeader title="Bank Name" />
                <Field component="select" name="banks" className={formik.touched.bankfullname && formik.errors.bankfullname ? "form-control is-invalid" : "form-control"} onChange={(e) => { formik.handleChange(e); handleChangeBranchName(e); }} > <option value="">Select</option> {bankNames} </Field>
                <ErrorMessage name="banks" component={"div"} className="text-error" />
              </OFMSUI.Col>
            </OFMSUI.Row>
            <OFMSUI.Row>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                <LabelHeader title="Branch Name" />
                <Field component="select" name="banknameaccountno" className={formik.touched.banknameaccountno && formik.errors.banknameaccountno ? "form-control is-invalid" : "form-control"} onChange={(e) => { formik.handleChange(e); }} >
                  <option value="">Select</option>
                  {branch}
                </Field>
                <ErrorMessage name="banknameaccountno" component={"div"} className="text-error" />
              </OFMSUI.Col>
              <GetDetails />

            </OFMSUI.Row>

            {tableEnable && (
              <>

                <OFMSUI.Row className="mb-3"></OFMSUI.Row>
                <OFMSUI.Row>
                  <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3" >
                    <div className="input-group"> <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                      <input type="text" id="#filterInput" placeholder="Search " style={{ width: "25%" }} className="form-control input-lg" value={searchText} onChange={handleSearchBankBook} ></input>
                    </div>
                  </OFMSUI.Col>

                  <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end" >
                    <ExportToExcelButton tableId="my-GeneratePDF" filename="BankBookReport" sheet="tablexls" buttonText="Excel" />
                  </OFMSUI.Col>
                </OFMSUI.Row>
                <div style={{ overflow: "auto", maxHeight: "700px" }}>
                  <Table striped bordered hover id="my-GeneratePDF">
                    <thead className="fw-bold">
                      <tr style={{ backgroundColor: "#f2f2f2" }}> <th colSpan={11}> <h6><center> Bank Book Report from &nbsp; {moment(formik.values.fromDate).format("DD-MM-YYYY")} &nbsp;to &nbsp; {moment(formik.values.toDate).format("DD-MM-YYYY")} </center></h6> </th> </tr>
                      <tr className="table_countshead"> <th>S No.</th> <th>Date</th> <th>Receipt No. /  Voucher No.</th> <th>Recievied From / Paid To</th> <th>Mode</th> <th>Inst. Reference No.</th> <th>Particulars</th> <th className="text-center">Head of Accounts</th> <th>Bank Name & Account No.</th> <th className="text-center">Debit</th> <th className="text-center">Credit</th> </tr>
                    </thead>
                    <tbody> {filteredDataBankBook?.length === 0 || filteredDataBankBook === undefined ? (<tr> <td colSpan="11" style={{ textAlign: "center" }}> No data found </td> </tr>) : (filteredDataBankBook.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td style={{ width: "100px" }}>{item.to_char}</td>
                        <td className="text-right">{item.receiptno}</td> <td>{item.name}</td> <td>{item.mode}</td> <td>{item.cheque_dd_receipt_no}</td> <td style={{ width: "400px" }}>{item.receipt_description}</td> <td className="text-right">{item.no_of_subheads}</td> <td>{item.banknameaccountno}</td> <td className="text-right"> {parseFloat(item.receiptamount).toFixed(2)} </td> <td className="text-right"> {parseFloat(item.paymentamount).toFixed(2)} </td> </tr>))
                    )}
                    </tbody>
                    <tfoot> <tr className="table_countshead" style={{ textAlign: "end" }}> <td colSpan={9} > Total Amount in Rs /-</td>
                      <td >{filteredDataBankBook?.reduce((a, v) => a + parseFloat(v.receiptamount || 0), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      <td >{filteredDataBankBook?.reduce((a, v) => a + parseFloat(v.paymentamount || 0), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    </tr> </tfoot>
                  </Table>
                </div>
              </>
            )}
          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </div>
  );
};

export default BankBookReport;
